import { memo, useCallback } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const CONTAINER_MIN_HEIGHT = 320;
const CONTAINER_STYLE = { minHeight: CONTAINER_MIN_HEIGHT };
const DISCOUNT_CODES: { code: string; description: string }[] = [
  { code: "24OFF", description: "24 month free" },
  { code: "DISCOUNT12", description: "12 month free" },
  { code: "WAIVE6", description: "6 month free" },
  { code: "COMP3", description: "3 month free" },
  { code: "1COMP", description: "1 month free" },
  { code: "53OFF", description: "50% off for 3 months" },
  { code: "56OFF", description: "50% off for 6 months" },
  { code: "512OFF", description: "50% off for 12 months" },
];

interface ConfirmationStepProps {
  selectedMembership: string;
  isAnnualMembership: "monthly" | "annual";
  membershipPrice?: number;
  discountCode?: string;
}

function ConfirmationStepInner({
  selectedMembership,
  isAnnualMembership,
  membershipPrice = 0,
  discountCode,
}: ConfirmationStepProps) {
  const navigate = useNavigate();

  const handleProceed = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  return (
    <div
      className="d-flex flex-column gap-4 p-4 rounded-4 bg-white"
      style={CONTAINER_STYLE}
    >
      <div className="text-center">
        <h4 className="fw-bold mb-3">JazakAllah khair</h4>
        <p className="text-muted">
          Thanks for purchasing the{" "}
          <span className="fw-semibold">{selectedMembership}</span>. Below is a
          confirmation of your purchase.
        </p>
      </div>

      <hr />

      <div className="d-flex justify-content-between px-2">
        <span className="fw-medium">
          {(isAnnualMembership === "annual" ? "Annual" : "Monthly") +
            " " +
            selectedMembership}
          :
        </span>
        <span className="fw-bold">£{membershipPrice.toFixed(2)}</span>
      </div>
      {discountCode &&
        !(discountCode === "512OFF" && isAnnualMembership === "monthly") && (
          <>
            <div className="d-flex justify-content-between px-2">
              <span className="fw-medium">Discount Code:</span>
              <span className="fw-bold">{discountCode}</span>
            </div>
            <div className="d-flex justify-content-between px-2">
              <span className="fw-medium">Discount Applied:</span>
              <span className="fw-bold">
                {DISCOUNT_CODES.find((dc) => dc.code === discountCode)
                  ?.description || "No discount"}
              </span>
            </div>
          </>
        )}
      <hr />
      <p className="text-center mb-0">Click below to complete your profile</p>
      <Button className="m-auto px-5" onClick={handleProceed}>
        Proceed to Dashboard
      </Button>
    </div>
  );
}

ConfirmationStepInner.displayName = "ConfirmationStep";

const ConfirmationStep = memo(ConfirmationStepInner);
ConfirmationStep.displayName = "ConfirmationStep";

export default ConfirmationStep;
